const MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
] as const;

interface CalendarDateParts {
  year: number;
  month: number;
  day: number;
}

function isValidDate({ year, month, day }: CalendarDateParts): boolean {
  const date = new Date(Date.UTC(year, month - 1, day));
  return date.getUTCFullYear() === year && date.getUTCMonth() === month - 1 && date.getUTCDate() === day;
}

function parseCalendarDate(value: string): CalendarDateParts | null {
  const raw = value.trim();
  const iso = /^(\d{4})-(\d{2})-(\d{2})(?:T.*)?$/.exec(raw);
  const us = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec(raw);

  const parts = iso
    ? { year: Number(iso[1]), month: Number(iso[2]), day: Number(iso[3]) }
    : us
      ? { year: Number(us[3]), month: Number(us[1]), day: Number(us[2]) }
      : null;

  return parts && isValidDate(parts) ? parts : null;
}

export function formatLongCalendarDate(value?: string): string {
  if (!value) return "—";
  const parts = parseCalendarDate(value);
  if (!parts) return value;
  return `${String(parts.day).padStart(2, "0")} ${MONTH_NAMES[parts.month - 1]}, ${parts.year}`;
}

export function formatNumericCalendarDate(value?: string): string {
  if (!value) return "—";
  const parts = parseCalendarDate(value);
  if (!parts) return value;
  return `${String(parts.month).padStart(2, "0")}/${String(parts.day).padStart(2, "0")}/${parts.year}`;
}
